<template>
    <AppHeader />
  
    <div class="container mx-auto p-4">
      <div class="max-w-3xl mx-auto bg-white dark:bg-slate-800 rounded-lg shadow-md overflow-hidden
                  text-gray-900 dark:text-gray-100">
        <div class="p-4 border-b dark:border-slate-700">
          <h1 class="text-xl font-semibold">Ajuda & Guia Rápido</h1>
          <p class="text-sm text-gray-500 dark:text-gray-400">Como usar o sistema de registros diários</p>
        </div>
  
        <div class="p-4 space-y-4">
          <!-- Guia rápido -->
          <section class="space-y-2">
            <h2 class="text-lg font-semibold">Guia rápido</h2>
            <ol class="list-decimal pl-5 space-y-1 text-sm">
              <li>Faça login (ou cadastre-se) com seu e-mail corporativo.</li>
              <li>Caso precise mudar de senha, clique com o botão esquerdo do mouse no círculo verde com as iniciais do seu nome no cabeçalho.</li>
              <li>Na página <span class="font-medium">Formulário</span>, o campo <em>Colaborador</em> é preenchido automaticamente.</li>
              <li>Informe a <em>Data de início</em> da sua atividade, também informando o horário.</li>
              <li>Escolha a <em>Atividade</em> da sua unidade. Digite para filtrar e pressione <kbd>Enter</kbd> para selecionar.</li>
              <li>Opcional: preencha <em>Observações</em> e clique <span class="font-medium">Enviar</span>.</li>
              <li>A data e o horário de término da atividade são registrados no momento que você enviar, portanto, preencha o formulário assim que terminar a atividade.</li>
              <li>Veja seus lançamentos em <span class="font-medium">Registros</span>.</li>
            </ol>
          </section>
  
          <!-- Dicas do seletor pesquisável -->
          <details class="group">
            <summary class="cursor-pointer select-none py-2 px-3 rounded-md bg-gray-50 dark:bg-slate-700/60
                             hover:bg-gray-100 dark:hover:bg-slate-700 text-sm font-medium">
              Dicas do seletor de atividades (pesquisável)
            </summary>
            <div class="mt-2 px-3 text-sm text-gray-700 dark:text-gray-300">
              <ul class="list-disc pl-5 space-y-1">
                <li>Comece a digitar para filtrar a lista.</li>
                <li>Use <kbd>↑</kbd>/<kbd>↓</kbd> para navegar e <kbd>Enter</kbd> para escolher.</li>
                <li><kbd>Esc</kbd> fecha a lista. Clique no <span class="font-medium">×</span> para limpar.</li>
                <li>As atividades exibidas pertencem à sua <em>unidade</em>. Se algo estiver faltando, peça ao administrador.</li>
              </ul>
            </div>
          </details>
  
          <!-- Registros -->
          <details class="group">
            <summary class="cursor-pointer select-none py-2 px-3 rounded-md bg-gray-50 dark:bg-slate-700/60
                             hover:bg-gray-100 dark:hover:bg-slate-700 text-sm font-medium">
              Sobre a página “Registros”
            </summary>
            <div class="mt-2 px-3 text-sm text-gray-700 dark:text-gray-300">
              <ul class="list-disc pl-5 space-y-1">
                <li>Você vê apenas <em>seus</em> registros.</li>
                <li>É possível excluir um registro seu. A edição é limitada para manter a integridade dos dados.</li>
              </ul>
            </div>
          </details>
  
          <!-- Solução de problemas -->
          <details class="group">
            <summary class="cursor-pointer select-none py-2 px-3 rounded-md bg-gray-50 dark:bg-slate-700/60
                             hover:bg-gray-100 dark:hover:bg-slate-700 text-sm font-medium">
              Solução de problemas comuns
            </summary>
            <div class="mt-2 px-3 text-sm text-gray-700 dark:text-gray-300 space-y-2">
              <p><span class="font-medium">Redireciona para login?</span> O token expirou. Entre novamente.</p>
              <p><span class="font-medium">Atividades vazias?</span> Verifique sua unidade ou contate o administrador para incluir o catálogo.</p>
              <p><span class="font-medium">Erro de hora de início?</span> A atividade não pode ter sido iniciada no momento de envio do formulário, nem antes das 7h ou depois das 19h.</p>
              <p><span class="font-medium">Interface estranha?</span> Experimente alternar o tema no ícone do topo (claro/escuro).</p>
            </div>
          </details>
  
          <!-- Contato -->
          <section class="pt-2 border-t dark:border-slate-700">
            <p class="text-sm text-gray-600 dark:text-gray-400">
              Precisa de ajuda? Fale com o Luiz ou com o Ivan da GESTD:
            </p>
            <p class="text-sm text-gray-600 dark:text-gray-400">
              luiz.branco@goias.gov.br
            </p>
            <p class="text-sm text-gray-600 dark:text-gray-400">
              ivan.pereira@goias.gov.br
            </p>
            <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Versão do app: 1.0.0</p>
          </section>
        </div>
      </div>
    </div>
  
  </template>
  
  <script>
  import AppHeader from './Header.vue'
  
  export default {
    name: 'HelpPage',
    components: { AppHeader },
  }
  </script>
  